///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, Signal } from '@angular/core';
import { UserActivityService } from './user-activity.service';

@Component({
    selector: 'winde-auto-logout-modal',
    templateUrl: './auto-logout-modal.component.html',
    standalone: false
})
export class AutoLogoutModalComponent {
    readonly counter: Signal<number>;

    constructor(private readonly userActivityService: UserActivityService) {
        this.counter = this.userActivityService.getCountdownCounter();
    }
}
